
export default {
  name: 'Header',
  props: {
    author: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasSocial() {
      return Object.values(this.author.seo.social).some((value) => {
        return value !== ''
      })
    },
  },
}
